import axios from 'axios';
import { handleAuthError, isTokenExpired } from '../utils/authUtils';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8003';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('mipa_token');
    
    // Don't check expiration here - let backend validate
    // This prevents false positives from token decode errors
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      handleAuthError('Your session has expired. Please login again.');
    } else if (error.response?.status === 403) {
      // Forbidden - user doesn't have permission
      if (window.showToast) {
        window.showToast('You do not have permission to perform this action.', 'error');
      }
    } else if (error.response?.status >= 500) {
      // Server error
      if (window.showToast) {
        window.showToast('Server error. Please try again later.', 'error');
      }
    }
    return Promise.reject(error);
  }
);

export const fetchProperties = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    
    // Add pagination
    params.append('page', filters.page || 1);
    params.append('limit', filters.limit || 20);
    
    // Add filters
    if (filters.property_type) {
      params.append('property_type', filters.property_type);
    }
    if (filters.min_price) {
      params.append('min_price', filters.min_price);
    }
    if (filters.max_price) {
      params.append('max_price', filters.max_price);
    }
    
    const response = await api.get(`/properties?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching properties:', error);
    throw error;
  }
};

export const fetchPropertyDetails = async (propertyId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/properties/${propertyId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching property details:', error);
        throw error;
    }
};

export const submitQuery = async (query) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/chat`, { message: query });
        return response.data;
    } catch (error) {
        console.error('Error submitting query:', error);
        throw error;
    }
};

export const fetchAddressDetails = async (address) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/full-analysis`, { address: address });
        return response.data;
    } catch (error) {
        console.error('Error fetching address details:', error);
        throw error;
    }
};